import { getLanguageTag, ocapiClient, registerOrderAction } from '@vista/omnichannel-components-domain';
import { PaymentCardsClient } from '@vista-digital/embedded-payments';
import { MemberPaymentCardWalletFormActionType as ActionType } from './form/form-action-type';
export const createPaymentCardsClient = (props) => {
    const { paymentMethodId, containerRef, childContainerClassName, redirectReturnUrl, onAddPaymentCardSuccessful, onAddPaymentCardFailed, dispatch } = props;
    if (!containerRef.current)
        throw new Error('Cannot create PaymentCardsClient without a container element.');
    let deregisterAction;
    return new PaymentCardsClient({
        webPaymentMethodId: paymentMethodId,
        container: containerRef.current,
        childContainerClassName: childContainerClassName,
        ocapiClient: ocapiClient.instance,
        redirectReturnUrl: redirectReturnUrl || window.location.href,
        languageTag: getLanguageTag(),
        events: {
            onAddPaymentCardStarted: () => {
                deregisterAction = registerOrderAction('member-payment-card-wallet');
                dispatch({ type: ActionType.AddPaymentCardStarted });
            },
            onAddPaymentCardSuccessful: cardProxy => {
                if (deregisterAction)
                    deregisterAction();
                const memberPaymentCard = mapPaymentCardProxyToMemberPaymentCard(cardProxy);
                onAddPaymentCardSuccessful(memberPaymentCard);
            },
            onAddPaymentCardFailed: error => {
                if (deregisterAction)
                    deregisterAction();
                onAddPaymentCardFailed(error);
            },
            onAddPaymentCardButtonStateChanged: buttonState => {
                dispatch({ type: ActionType.AddPaymentCardButtonStateChanged, buttonState });
            }
        }
    });
};
const mapPaymentCardProxyToMemberPaymentCard = (cardProxy) => {
    const { id, isDefault, maskedCardNumber, cardExpiryMonth, cardExpiryYear, cardType } = cardProxy;
    return {
        id,
        isPrimary: isDefault,
        cardDetails: {
            maskedCardNumber,
            type: cardType,
            expiryMonth: cardExpiryMonth,
            expiryYear: cardExpiryYear
        }
    };
};
